import { ReactNode } from "react";
import { useTheme } from "./hooks/useTheme";

interface PageSectionProps {
  heading: string;
  children?: ReactNode;
}

export const ComingSoon = ({ heading, children }: PageSectionProps) => {
  const { themeStyles } = useTheme();

  return (
    <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
      <div className={`w-full ${themeStyles.main.tailwindMainBg} border ${themeStyles.main.borderColor} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.5`}>
        <h2 className={`text-lg font-semibold px-2 ${themeStyles.main.textHeadingColor}`}>{heading}</h2>
        <div className="px-2">
          {children}
        </div>
      </div>
    </div>
  );
};
